export const isValidUsername = (str: string) =>
  ['admin', 'editor'].indexOf(str.trim()) >= 0

export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)

export const isValidDomain = (str: string) => {
  // Regex to check valid
  // eslint-disable-next-line no-useless-escape
  const regex = new RegExp(/^(?:(?:(?:[a-zA-z\-]+)\:\/{1,3})?(?:[a-zA-Z0-9])(?:[a-zA-Z0-9\-\.]){1,61}(?:\.[a-zA-Z]{2,})+|\[(?:(?:(?:[a-fA-F0-9]){1,4})(?::(?:[a-fA-F0-9]){1,4}){7}|::1|::)\]|(?:(?:[0-9]{1,3})(?:\.[0-9]{1,3}){3}))(?:\:[0-9]{1,5})?$/) // prettier-ignore
  if (str === null || regex.test(str) === false) {
    return false
  }
  return true
}

export const domainValidator = (
  _rule: any,
  value: any,
  callback: (arg?: Error) => void
) => {
  if (isValidDomain(value)) {
    return callback()
  }

  return callback(new Error('Please enter correct domain'))
}
